<div class="dialog p50">
  <h2>je wachtwoord verifiëren</h2>

  <form [formGroup]="form" class="form">
    <div [ngClass]="{ 'input-error': submitted && f.password.errors }">
      <label for="password" class="form-label">{{'password' | translate}}</label>
      <div class="relative">
        <input formControlName="password" appShowPasswordToggle id="password" type="password">
      </div>
      <div class="errors">
        <div *ngIf="f.password.errors?.required">{{'password.required' | translate}}</div>
        <div *ngIf="f.password.errors?.minlength">{{'password.minLength' | translate}}</div>
      </div>
      <div class="error"><div *ngIf="passwordError">wachtwoord is incorrect</div></div>
    </div>
  </form>

  <div class="spacer-large"></div>
  <div>
    <button class="block float-left btn arrow-left" style="margin-bottom:14px;" (click)="cancel()">annuleren</button>
    <button class="block float-right btn inverted check" style="margin-bottom:14px;" (click)="submit(form.value)">versturen</button>
    <div class="clearFix"></div>
  </div>
</div>
